/**
 * @module app.shared
 */

import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class EssBodyClassCustomAttribute {

    @bindable({ primaryProperty: true, changeHandler: 'classNameChanged' })
    public className: string = '';

    private bodyElement: HTMLElement | null = null;

    constructor() { }

    protected attached(): void {
        this.bodyElement = window.document.body;
        this.addClasses(this.className);
    }

    protected detached(): void {
        this.removeClasses(this.className);
        this.bodyElement = null;
    }

    protected classNameChanged(newValue: string, oldValue: string) {
        if(newValue !== oldValue) {
            this.removeClasses(oldValue);
            this.addClasses(newValue);
        }
    }

    private addClasses(classes: string): void {
        if(this.bodyElement && classes && classes.length > 0) {
            for(var cssClass of classes.split(' ')) {
                if(cssClass.length > 0) {
                    this.bodyElement.classList.add(cssClass);
                }
            }
        }
    }

    private removeClasses(classes: string): void {
        if(this.bodyElement && classes && classes.length > 0) {
            for(var cssClass of classes.split(' ')) {
                if(cssClass.length > 0) {
                    this.bodyElement.classList.remove(cssClass);
                }
            }
        }
    }

}
